const BASE_URL = process.env.REACT_APP_BASE_URL;

const ApiRequestHeaderFormatter = () => {
  const headers = { "Content-Type": "application/json" };
  try {
    const logindata = JSON.parse(localStorage.getItem("logindata"));
    const token = logindata?.data?.token;
    if (token) headers.Authorization = `Bearer ${token}`;
  } catch (e) {}
  return headers;
};

const ApiRequestParamsFormatter = (endpoint, method, params) => {
  if (method === "GET" && params && Object.keys(params).length) {
    const query = new URLSearchParams(params).toString();
    return `${BASE_URL}/${endpoint}?${query}`;
  }
  return `${BASE_URL}/${endpoint}`;
};

const ApiRequestFormatter = (method, params) => {
  const request = { method, headers: ApiRequestHeaderFormatter() };
  if (method !== "GET" && params) request.body = JSON.stringify(params);
  return request;
};

export const ApiRequestInterceptor = async (endpoint, method = "GET", params) => {
  try {
    const response = await fetch(
      ApiRequestParamsFormatter(endpoint, method, params),
      ApiRequestFormatter(method, params)
    );
    let data = null;
    try {
      data = await response.json();
    } catch (e) {}
    return { code: response.status, data };
  } catch (error) {
    return { code: 500, data: { message: error.message } };
  }
};
